import * as yup from 'yup';

export const immediateFamilyValidation = yup
  .string()
  .nullable()
  .when('isPoliticallyExposed', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('This field is required'),
  });

export const politicalOrganizationValidation = yup
  .string()
  .nullable()
  .when('isPoliticallyExposed', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('This field is required'),
  });
